import classNames from "classnames";

export const SkewBox = ({background, title}) => {
    return (
        <div style={{backgroundColor:"#fff"}}>
            <div 
                className={classNames(
                    "notes-bg",
                    "page-bg"
                )}
                style={{backgroundImage: `url(${background})`}}
            >
                <div className="bg-cover">
                    <span className="bg-text">{title}</span>
                </div>
            </div>
            
        </div>
    );
}